import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/payroll-management-system/payslip-generation/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "payslip-generation" entry is kept); the seo block below is a fallback.

export const payslipGeneration: ContentPage = {
  slug: "payroll-management-system/payslip-generation",
  template: "hrmsFeature",
  seo: {
    title: "Effortless Payslip Generation for Every Cycle",
    description: "Automate payslip generation, providing detailed breakdowns of earnings and deductions, enhancing clarity and compliance in payroll processes.",
    keywords: [
      "payslip generation",
      "automated payslips",
      "digital payslip distribution",
      "detailed payroll reports",
      "employee payslip access.",
    ],
    ogImage: "/assets/data/seoimages/payslip-generation.webp",
  },
  leaf: {
    hero: {
      caption: "Payslip Generation",
      title: "Generate Comprehensive Payslips Effortlessly",
      description: "Provide clear and detailed payslips automatically each payroll cycle, enhancing transparency and trust with your employees.",
      h1: "caption",
    },
    split: {
      title: "Automated and Detailed Payslip Distribution",
      bullets: [
        { title: "Detailed Earnings Breakdown", description: "Clearly list all salary components and deductions." },
        { title: "Digital Payslip Distribution", description: "Send payslips via email or employee portal securely." },
        { title: "Custom Payslip Templates", description: "Tailor payslip layouts to reflect your branding." },
        { title: "Secure Access Anytime", description: "Employees can access payslips anytime, anywhere." },
      ],
      image: "/assets/images/img/product/hrms/payrollms/payslip-generation_info.webp",
      imageAlt: "payslip-generation_info",
    },
    cardsHeading: {
      title: "Key Features of Payroll Management System",
      description: "Optimize Payroll management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Overtime and Leave Calculations",
        href: "/hrms-software/payroll-management-system/overtime-leave-calculations",
        description: "Streamline how you handle overtime pay and leave deductions, ensuring fairness and compliance in your payroll processes.",
        image: "/assets/images/img/product/hrms/payrollms/overtime-leave-calculations.webp",
        imageAlt: "overtime-leave-calculations",
      },
      {
        title: "Tax and Compliance Management",
        href: "/hrms-software/payroll-management-system/tax-and-compliance-management",
        description: "Manage your payroll taxes and regulatory compliance effortlessly with our comprehensive tax management system.",
        image: "/assets/images/img/product/hrms/payrollms/tax-and-compliance-management_imge.webp",
        imageAlt: "tax-and-compliance-management",
      },
      {
        title: "Custom Deductions",
        href: "/hrms-software/payroll-management-system/custom-deductions",
        description: "Tailor deductions for taxes, benefits, and other payroll elements to match your company policies and employee agreements.",
        image: "/assets/images/img/product/hrms/payrollms/custom-deductions.webp",
        imageAlt: "custom-deductions",
      },
      {
        title: "Integration with Accounting",
        href: "/hrms-software/payroll-management-system/integration-with-accounting",
        description: "Sync your payroll data directly with your accounting software to streamline financial management and reporting.",
        image: "/assets/images/img/product/hrms/payrollms/integration-with-accounting_image.webp",
        imageAlt: "integration-with-accounting",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Enhance Payroll Transparency with Automated Payslips!",
    relatedBlogsKeyword: "automated-payslip-generation,getbiz-payroll-review",
    metaKey: "payslip-generation",
  },
  sections: [],
};
